import { useState } from 'react'
import { Pressable, View } from 'react-native'
import { LiveChatWidget } from '@livechat/widget-react'
import { LinearGradient } from 'expo-linear-gradient'
import { useTranslation } from 'react-i18next'

import { brandTheme } from '@/config/brandTheme'
import { LIVECHAT_LICENSE } from '@/constants/config'
import { cn } from '@/utils/cn'
import { CustomerService } from '@/components/icon'

export default function LandingCustomerService() {
  const { t } = useTranslation()
  const [visibility, setVisibility] = useState<'hidden' | 'minimized' | 'maximized'>('hidden')

  return (
    <>
      <Pressable
        accessibilityLabel={t('support:contactCustomerService')}
        accessibilityRole={'button'}
        onPress={() => setVisibility('maximized')}
      >
        {({ pressed }) => (
          <View className={cn('items-center', pressed && 'opacity-50')}>
            <LinearGradient colors={[brandTheme.DEFAULT, brandTheme.hover]} style={{ borderRadius: 28, padding: 16 }}>
              <CustomerService className={'size-6 text-white'} />
            </LinearGradient>
          </View>
        )}
      </Pressable>
      <LiveChatWidget
        license={LIVECHAT_LICENSE}
        onVisibilityChanged={(event) => {
          switch (event.visibility) {
            case 'hidden':
            case 'minimized':
              setVisibility('hidden')
              break
            case 'maximized':
              break
          }
        }}
        visibility={visibility}
      />
    </>
  )
}
